import moment from 'moment-timezone'
import startsWith from 'lodash/startsWith'
const tzPrefixes = ['Canada', 'US']

const timezones = moment.tz.names().filter(name => {
  return tzPrefixes.some(prefix => startsWith(name, prefix))
}).reduce((map, tzname) => ({
  ...map,
  [tzname]: tzname
}), {})

export const getTzName = tz => timezones[tz] || null

export default timezones
